import React from 'react'
import SocialLinks from '../components/sociallinks/SocialLinks'
import NavBar from '../components/navbar/NavBar'
import BuyImage from '../assets/how-to-buy.jpg'
import Footer from '../components/footer/Footer'
import ScrollTop from '../components/scrolltop/ScrollTop'
import Games from '../components/games/Games'

const GameView = () => {
    return (
        <>
            <SocialLinks />
            <NavBar />
            <div className="container">
                <div className="row">
                    <div className="col-md-10 col-md-offset-1">
                        <div className="buy-container">
                            {/* <img src={BuyImage} alt="" className="img-responsive" /> */}
                            <Games />
                        </div>
                    </div>
                </div>
            </div>
            <ScrollTop />
            <Footer />
        </>
    )
}

export default GameView
